import React from 'react';
import { Trash2, Copy } from 'lucide-react';

interface DeckCardProps {
  deck: {
    id: number;
    title: string;
    description?: string;
    created_at: string;
    updated_at: string;
  };
  onClick: () => void;
  onDelete: () => void;
  onDuplicate: () => void;
}

export const DeckCard: React.FC<DeckCardProps> = ({ deck, onClick, onDelete, onDuplicate }) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInDays = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
    
    if (diffInDays === 0) {
      return 'Today';
    } else if (diffInDays === 1) {
      return 'Yesterday';
    } else if (diffInDays < 7) {
      return `${diffInDays} days ago`;
    } else {
      return date.toLocaleDateString();
    }
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDelete();
  };

  const handleDuplicate = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDuplicate();
  };

  return (
    <div className="group relative w-full p-6 bg-gray-800 rounded-lg border border-gray-700 hover:border-gray-600 transition-colors flex items-center space-x-4">
      <button
        onClick={onClick}
        className="flex-1 flex items-center space-x-4 text-left"
      >
        <div className="w-12 h-12 bg-gray-700 rounded flex-shrink-0" />
        <div className="flex-1">
          <h3 className="text-lg font-medium text-white">{deck.title}</h3>
          <p className="text-sm text-gray-400">{formatDate(deck.updated_at)}</p>
        </div>
      </button>
      <div className="opacity-0 group-hover:opacity-100 transition-opacity flex space-x-2">
        <button
          onClick={handleDuplicate}
          className="p-2 hover:bg-gray-700 rounded-lg text-gray-400 hover:text-blue-400"
          title="Duplicate deck"
        >
          <Copy className="w-5 h-5" />
        </button>
        <button
          onClick={handleDelete}
          className="p-2 hover:bg-gray-700 rounded-lg text-gray-400 hover:text-red-400"
          title="Delete deck"
        >
          <Trash2 className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};